import { render } from "./TalksView.vue?vue&type=template&id=480f4b68&scoped=true"
import script from "./TalksView.vue?vue&type=script&lang=js"
export * from "./TalksView.vue?vue&type=script&lang=js"

import "./TalksView.vue?vue&type=style&index=0&id=480f4b68&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adoranwodo2.0/adoranwodo2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-480f4b68"]])

export default __exports__